import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { hallsAPI } from "../api/api";
import { HallsActionTypes } from "../actions/actionTypes";

function* getLicenseActivity(action) {
    try {
        let activity = yield call(() =>
            hallsAPI.getLicensesActivity({
                page: action.payload.page,
                top: action.payload.top,
                serverId: action.payload.serverId
            })
        );

        yield put({
            type: HallsActionTypes.GET_LICENSE_ACTIVITY_SUCCESS,
            payload: {
                activities: activity.data.results,
                serverId: action.payload.serverId
            }
        });
    } catch (e) {
        API.handleError(e.response);

        yield put({
            type: HallsActionTypes.GET_LICENSE_ACTIVITY_FAIL,
            message: e.message
        });
    }
}

export function* getLicenseActivityWatcher() {
    yield takeLatest(HallsActionTypes.GET_LICENSE_ACTIVITY, getLicenseActivity);
}
